export default __webpack_public_path__ + "static/media/laravel.d24aa214.png";